export default __webpack_public_path__ + "static/mode-single-dark-5a104d40c4378950bbcc94b315b0eadd.png";